import _extends from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import CommonFooter from '~/components/CommonFooter';
export default {
  name: "ProjectDetails",
  components: {
    CommonFooter: CommonFooter
  },
  data: function data() {
    return {
      position: '0px',
      i: 0
    };
  },

  methods: {
    scrollDown: function scrollDown() {
      var hei = parseInt(document.querySelector('.project-detail_wrap').clientHeight);
      this.i++;
      var count = Math.ceil((hei - 301) / this.winHeight);
      if (this.i >= count) {
        this.i = count;
      }
      this.position = this.winHeight * this.i < hei - 301 ? -(this.winHeight - 60) * this.i + 'px' : -(hei - 301) + 'px';
      document.removeEventListener('mousewheel', this.mousewheel);
    },
    scrollUp: function scrollUp() {
      this.i--;
      if (this.i < 0) {
        this.i = 0;
      }
      this.position = -(this.winHeight - 60) * this.i + 'px';
      document.removeEventListener('mousewheel', this.mousewheel);
    },
    mousewheel: function mousewheel(e) {
      var _this = this;

      e = e || window.event;
      var wheelDelta = e.wheelDelta;
      if (wheelDelta > 0) {
        this.scrollUp();
        setTimeout(function () {
          document.addEventListener('mousewheel', _this.mousewheel, false);
        }, 1500);
      } else {
        this.scrollDown();
        setTimeout(function () {
          document.addEventListener('mousewheel', _this.mousewheel, false);
        }, 1500);
      }
    }
  },
  computed: _extends({}, mapState(['winHeight']), {
    up: function up() {
      return {
        height: this.winHeight - 60 + 'px'
      };
    },
    marginTop: function marginTop() {
      return {
        marginTop: this.position
      };
    }
  }),
  mounted: function mounted() {
    var _this2 = this;

    $('.project-details').scroll(function () {

      if ($('.project-details').scrollTop() === 0 && window.screen.width > 768) {

        _this2.$store.state.top = true;
      } else {
        _this2.$store.state.top = false;
      }
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CommonContent.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/CommonContent.vue
// module chunks = 0 1 3 5 6 7 8 9 10 11 12 13 14